import React from 'react';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Hero } from './sections/Hero';
import { ModelsSection } from './sections/ModelsSection';
import { ComparisonTable } from './sections/ComparisonTable';
import { CTASection } from './sections/CTASection';
export function App() {
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <Header data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <Hero data-id="element-3" />
        <ModelsSection data-id="element-4" />
        <ComparisonTable data-id="element-5" />
        <CTASection data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}